require("jquery-blockui")

IndicatorDirective = ->
  restrict: 'A'
  scope:
    isLoading: "=gnpIndicator"
  replace: true
  link: (scope, elem) ->
    scope.$watch 'isLoading', ->
      if scope.isLoading
        elem.block
          message: '<div class="loader">Loading...</div>'
          css:
            border: "none"
            backgroundColor: 'transparent'
          overlayCSS:
            backgroundColor: '#fff'
            opacity: 0.3
      else
        elem.unblock()

module.exports = IndicatorDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/animate/indicator-directive.coffee